import { me } from '@connected/api-client/data/auth/me';
import { removeAuthentication } from '@connected/api-client/lib/authentication';
import { DOMAIN_KEYS } from '@connected/api-client/lib/portal';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { queryClient } from '@/lib/query-client';

export const Route = createFileRoute('/(shared)/logout/')({
    validateSearch: z.object({
        from: z.enum(DOMAIN_KEYS).optional(),
        path: z.string().optional(),
    }),
    beforeLoad: async ({ search }) => {
        removeAuthentication();

        await queryClient.invalidateQueries(me.queryOptions());

        throw redirect({
            to: '/login',
            search: { from: search.from, redirectPath: search.path },
        });
    },
});
